import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { setDetailsQuotationData } from 'store/Order/actions/order';
import { IDetailsQuotationData } from 'types/Order.types';

// Mirrors the Formik values + validity into redux detailsQuotationData so the
// page's Create button can gate on validDetails and build the request body.
const FormObserver = () => {
  const { values, isValid } =
    useFormikContext<Omit<IDetailsQuotationData, 'validDetails'>>();
  const dispatch = useDispatch();
  const detailsQuotationData = useSelector(
    (state: IRootReducerState) => state.orderInfo.detailsQuotationData
  );

  useEffect(() => {
    const next: IDetailsQuotationData = { ...values, validDetails: isValid };
    if (JSON.stringify(next) !== JSON.stringify(detailsQuotationData)) {
      dispatch(setDetailsQuotationData(next));
    }
  }, [values, isValid, detailsQuotationData, dispatch]);

  return null;
};

export default FormObserver;
